import { useAuth0 } from "@auth0/auth0-react";
import LoginPrompt from "../Auth/LoginPrompt";
import { Container } from "react-bootstrap";
import Resources from "../Resources/Resources";

export default function PageResources() {
  const { isAuthenticated } = useAuth0();
  return (
    <div className="page-resources">
      <Container>
        <h1>Resources</h1>
        {isAuthenticated ? (
          <Resources />
        ) : (
          <LoginPrompt message="A network of resources to address your real estate challenges, complemented by exclusive discounts." />
        )}
      </Container>
    </div>
  );
}
